import _, { get, find } from 'lodash'
import moment from '../lib/moment.js'

export function searchCompanys(element) {
  const name = element.name.toLowerCase()
  const company_code = element.company_code.toLowerCase()
  return name.includes(this.toLowerCase()) || company_code.includes(this)
}

export function searchConfidentials(element) {
  const company = element.company.toLowerCase()
  const emp_name = element.emp_name.toLowerCase()
  const emp_code = element.emp_code.toLowerCase()
  return company.includes(this.toLowerCase())
  || emp_name.includes(this.toLowerCase())
  || emp_code.includes(this)
}

export function searchDepartments(element) {
  const name = element.name.toLowerCase()
  const department_code = element.department_code.toLowerCase()
  return name.includes(this.toLowerCase()) || department_code.includes(this)
}

export function searchDivisions(element) {
  const name = element.name.toLowerCase()
  const division_code = element.division_code.toLowerCase()
  return name.includes(this.toLowerCase()) || division_code.includes(this)
}

export function searchEmployees(element) {
  const nick_name = element.nick_name.toLowerCase()
  const name = `${element.first_name.toLowerCase()} ${element.last_name.toLowerCase()}`
  const emp_code = element.emp_code.toLowerCase()
  return name.includes(this.toLowerCase())
  || emp_code.includes(this)
  || nick_name.includes(this.toLowerCase())
}

export function searchLevels(element) {
  const name = element.name.toLowerCase()
  const level_code = element.level_code.toLowerCase()
  return name.includes(this.toLowerCase()) || level_code.includes(this)
}

export function searchLOBs(element) {
  const name = element.name.toLowerCase()
  const lob_code = element.lob_code.toLowerCase()
  return name.includes(this.toLowerCase()) || lob_code.includes(this)
}

export function searchPositions(element) {
  const name = element.name.toLowerCase()
  const position_code = element.position_code.toLowerCase()
  return name.includes(this.toLowerCase()) || position_code.includes(this)
}

export function searchStandardPrices(element) {
  const name = element.name.toLowerCase()
  const level_code = element.level_code.toLowerCase()
  return name.includes(this.toLowerCase()) || level_code.includes(this)
}

export function searchTeams(element) {
  const name = element.name.toLowerCase()
  const team_code = element.team_code.toLowerCase()
  return name.includes(this.toLowerCase()) || team_code.includes(this)
}

export function searchConsents(element) {
  const title = element.title.toLowerCase()
  const id = element._id.toLowerCase()
  return title.includes(this.toLowerCase()) || id.includes(this)
}

export function searchConsentLogs(element) {
  const name = `${element.first_name.toLowerCase()} ${element.last_name.toLowerCase()}`
  const emp_code = element.emp_code.toLowerCase()
  return name.includes(this.toLowerCase())
  || emp_code.includes(this)
}

/* eslint no-underscore-dangle: 0 */
export function checkModifiedBy(id, employeeList) {
  let name = ''
  for (let i = 0; i < _.get(employeeList, 'length'); i++) {
    if (employeeList[i]._id === id) {
      name = `${employeeList[i].first_name} ${employeeList[i].last_name}`
      break
    }
  }
  return name
}

export function searchPublicHoliday(element) {
  const description = element.description.toLowerCase()
  return description.includes(this.toLowerCase())
}

export function searchClient(element) {
  const name = get(element, 'name', '').toLowerCase()
  const contact_name = get(element, 'contact_name', '').toLowerCase()
  const contact_position = get(element, 'contact_position', '').toLowerCase()
  const client_code = get(element, 'client_code', '').toLowerCase()
  return name.includes(this.toLowerCase())
  || contact_name.includes(this.toLowerCase())
  || contact_position.includes(this.toLowerCase())
  || client_code.includes(this)
}

export function selectStatusWord(status) {
  if (status === 'PRESALE') return 'Pre-sale'
  else if (status === 'IMPLEMENTING') return 'Implementing'
  else if (status === 'DONE') return 'Done'
  else if (status === 'INACTIVE') return 'Inactive'
  else if (status === 'ACTIVE') return 'Active'
  return ''
}

export function selectStatusColor(status) {
  if (status === 'PRESALE') return '#F0AD4E'
  else if (status === 'IMPLEMENTING') return '#428BCA'
  else if (status === 'DONE') return '#5CB85C'
  else if (status === 'INACTIVE') return '#BBBBBB'
  else if (status === 'ACTIVE') return '#5CB85C'
  return ''
}

export function createLeaveTypeList(list) {
  const temp = [{ label: 'Choose Leave Type ID', leave_type_id: '' }]
  list.map((item) => {
    if (item.is_active) temp.push({ label: `${item.leave_type_code} - ${item.name}`, leave_type_id: item._id })
    return item
  })
  return temp
}

export function createProjectList(list) {
  const temp = []
  list.map((item) => {
    temp.push({ label: `${item.project_code} - ${item.project_name}`, project_id: item.project_id })
    return item
  })
  return temp
}

export function createLeaveTypeListWithoutDeductEntitlement(list) {
  const temp = [{ label: 'Choose Leave Type ID', leave_type_id: '' }]
  list.map((item) => {
    if (item.is_deduct_leave_entitlment && item.is_active) temp.push({ label: `${item.leave_type_code} - ${item.name}`, leave_type_id: item._id })
    return item
  })
  return temp
}

export function createApproverList(list/* , supervisor */) {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin') && localStorage.getItem('_id') !== approver._id) {
        temp.push({ label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name}`, approver_id: approver._id })
      }
      return approver
    })
  }
  return temp
}
export function createProjectApproverList(list) {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin')) {
        temp.push({
          label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
          name: `${approver.first_name} ${approver.last_name}`,
          value: approver._id,
          _id: approver._id,
        })
      }
      return approver
    })
  }
  return temp
}

export function createCompensateApproverList(list) {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin')) {
        temp.push({
          label: `${approver.code} - ${approver.name} (${approver.nick_name})`,
          name: `${approver.name}`,
          value: approver.id,
          approver_id_compensate: approver.id,
        })
      }
      return approver
    })
  }
  return temp
}

export function createProjectManagerList(list) {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin')
      && (get(approver, 'is_pm_role') || get(approver, 'is_project_approver_role'))) {
        temp.push({
          label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
          name: `${approver.first_name} ${approver.last_name}`,
          value: approver._id,
          _id: approver._id,
          is_project_approver_role: approver.is_project_approver_role,
        })
      }
      return approver
    })
  }
  return temp
}

export function createEmployeeList(list, lobs, departments) {
  const temp = []
  if (list !== undefined) {
    list.map(emp => {
      if (!get(emp, 'is_system_admin') && get(emp, 'is_active')) {
        const lob = find(lobs, { _id: emp.lob_id })
        const department = find(departments, { _id: emp.department_id })
        temp.push({
          label: `${emp.emp_code} - ${emp.first_name} ${emp.last_name}`,
          name: `${emp.first_name} ${emp.last_name}`,
          emp_code: emp.emp_code,
          first_name: emp.first_name,
          last_name: emp.last_name,
          nick_name: emp.nick_name,
          level: emp.level,
          employee_type: emp.employee_type,
          value: emp._id,
          lob: lob ? lob.name : '-',
          department: department ? department.name : '-',
          _id: emp._id,
        })
      }
      return emp
    })
  }
  return temp
}

export function createResourceList(list, lobs, departments) {
  const temp = []
  if (list !== undefined) {
    list.map(emp => {
      if (!get(emp, 'is_system_admin')) {
        const lob = find(lobs, { _id: emp.lob_id })
        const department = find(departments, { _id: emp.department_id })
        temp.push({
          label: `${emp.emp_code} - ${emp.first_name} ${emp.last_name}`,
          name: `${emp.first_name} ${emp.last_name}`,
          emp_code: emp.emp_code,
          first_name: emp.first_name,
          last_name: emp.last_name,
          nick_name: emp.nick_name,
          level: emp.level,
          employee_type: emp.employee_type,
          value: emp._id,
          lob: lob ? lob.name : '-',
          department: department ? department.name : '-',
          is_active: emp.is_active,
          _id: emp._id,
        })
      }
      return emp
    })
  }
  return temp
}

export function createPMSupervisorList(list) {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin') && ((get(approver, 'level') === 'VP' || get(approver, 'level') === 'Director') || get(approver, 'level') === 'Asst. VP')) {
        temp.push({
          label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
          name: `${approver.first_name} ${approver.last_name}`,
          value: approver._id,
          _id: approver._id,
        })
      }
      return approver
    })
  }
  return temp
}

export function createClientList(list) {
  const temp = []
  if (list !== undefined) {
    list.map(c => {
      temp.push({
        label: `${c.client_code} - ${c.name}`,
        name: c.name,
        value: c._id,
        _id: c._id,
      })
      return c
    })
  }
  return temp
}

export function checkLeaveType(id, list) {
  const leave_type = _.find(list, {
    leave_type_id: id,
  })
  return leave_type
}

export function searchLeaveEntitlement(element) {
  const leave_entitlement_code = element.leave_entitlement_code.toLowerCase()
  const name = element.name.toLowerCase()
  return name.includes(this.toLowerCase()) || leave_entitlement_code.includes(this.toLowerCase())
}

export function searchLeaveType(element) {
  const leave_type_code = element.leave_type_code.toLowerCase()
  const name = element.name.toLowerCase()
  return name.includes(this.toLowerCase()) || leave_type_code.includes(this)
}

export function searchLeaveRequest(element) {
  const name = `${(element.row_label !== undefined ? element.row_label : '').toLowerCase()}`
  const group = `${(element.group_label !== undefined ? element.group_label : '').toLowerCase()}`
  return name.includes(this.toLowerCase()) || group.includes(this.toLowerCase())
}

export function searchRequestInbox(element) {
  const emp_code = element.emp_code
  const name = `${element.name.toLowerCase()}`
  const lob = `${element.lob.toLowerCase()}`
  const position = `${element.position.toLowerCase()}`
  const status = `${element.status.toLowerCase()}`
  const type = `${get(element, 'type', '').toLowerCase()}`
  const leave_type = `${get(element, 'leave_type', '').toLowerCase()}`
  return name.includes(this.toLowerCase())
  || emp_code.includes(this)
  || lob.includes(this)
  || position.includes(this)
  || status.includes(this)
  || type.includes(this)
  || leave_type.includes(this)
}

export function searchYearOfService(element) {
  const emp_code = element.emp_code
  const name = `${element.first_name.toLowerCase()} ${element.last_name.toLowerCase()}`
  const company = element.company_name.toLowerCase()
  const lob = element.lob_name.toLowerCase()
  const department = element.department_name.toLowerCase()
  return name.includes(this.toLowerCase())
  || emp_code.includes(this)
  || company.includes(this.toLowerCase())
  || lob.includes(this.toLowerCase())
  || department.includes(this.toLowerCase())
}

export function searchLeaveHistory(element) {
  const emp_code = element.emp_code
  const name = element.emp_name.toLowerCase()
  const company = element.emp_company.toLowerCase()
  const lob = element.emp_lob.toLowerCase()
  const leave_type = element.leave_type_name.toLowerCase()
  return name.includes(this.toLowerCase())
  || emp_code.includes(this)
  || company.includes(this.toLowerCase())
  || lob.includes(this.toLowerCase())
  || leave_type.includes(this.toLowerCase())
}

export function searchProjectInformation(element) {
  const name = element.name.toLowerCase()
  const client_name = element.client.toLowerCase()
  const project_code = get(element, 'project_code', '') ? get(element, 'project_code', '').toLowerCase() : ''
  const project_type = element.project_type.toLowerCase()
  const lob = element.lob.toLowerCase()
  const key_project_manager = get(element, 'key_project_manager', '').toLowerCase()
  const status = element.status.toLowerCase()
  return name.includes(this.toLowerCase()) || client_name.includes(this.toLowerCase()) ||
  project_code.includes(this.toLowerCase()) || project_type.includes(this.toLowerCase()) ||
  lob.includes(this.toLowerCase()) || key_project_manager.includes(this.toLowerCase()) ||
  status.includes(this.toLowerCase())
}

export function findApproverName(id, list) {
  const approver_name = _.find(list, {
    _id: id,
  })
  return approver_name === undefined ? '' : `${approver_name.first_name} ${approver_name.last_name}`
}

export function findLeaveTypeName(id, list) {
  const leave_type_name = _.find(list, {
    _id: id,
  })
  return leave_type_name === undefined ? '' : leave_type_name.name
}

export function findLOBName(id, list) {
  const lob_name = _.find(list, {
    _id: id,
  })
  return lob_name === undefined ? '' : lob_name.name
}

export function findProjectName(id, list) {
  const project = _.find(list, {
    project_id: id,
  })
  return project === undefined ? '' : project.project_name
}

export function findCompanyName(id, list) {
  const company_name = _.find(list, {
    _id: id,
  })
  return company_name === undefined ? '' : company_name.name
}

export function findPositionName(id, list) {
  const position_name = _.find(list, {
    _id: id,
  })
  return position_name === undefined ? '' : position_name.name
}

export function findFullNameByID(id, list) {
  const name = _.find(list, {
    _id: id,
  })
  return name === undefined ? '' : `${name.first_name} ${name.last_name} (${name.nick_name})`
}

export function findNameByID(id, list) {
  const name = _.find(list, {
    _id: id,
  })
  return name === undefined ? '' : name.name
}

export function findProjectManagersByID(ids, list) {
  const managers = []
  if (ids && list) {
    ids.map(id => {
      const manager = _.find(list, {
        _id: id,
      })
      if (manager) managers.push(manager)
      return id
    })
  }
  return get(managers, 'length') > 1 ? `${get(managers[0], 'name')}, +${get(managers, 'length') - 1}` : get(managers[0], 'name', '-')
}

export function createListOfYears(list) {
  const years = []
  Object.keys(list).forEach(year => {
    years.push(year)
  })
  return years
}

export function createArrayOfInbox(data, users, companys, lobs, positions, leaveTypes) {
  const temp = []
  data.map(d => {
    const inbox = {}
    const user = _.find(users, {
      _id: d.user_id,
    })
    inbox.emp_code = get(user, 'emp_code', '')
    inbox.name = `${get(user, 'first_name', '')} ${get(user, 'last_name', '')}`
    inbox.nick_name = get(user, 'nick_name')
    const company = find(companys, { _id: get(user, 'company_id') })
    inbox.company = company ? company.name : '-'
    const lob = find(lobs, { _id: get(user, 'lob_id') })
    inbox.lob = lob ? lob.name : '-'
    const position = find(positions, { _id: get(user, 'position_id') })
    inbox.position = position ? position.name : '-'
    inbox.status = get(d, 'status')
    const leave_type = find(leaveTypes, { _id: get(d, 'leave_type_id') })
    inbox.leave_type = leave_type ? leave_type.name : 'Compensate Work'
    inbox.default_start_date = moment(get(d, 'start_date')).format('YYYYMMDD')
    inbox.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
    inbox.default_end_date = moment(get(d, 'end_date')).format('YYYYMMDD')
    inbox.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
    inbox.leave_time = get(d, 'leave_time')
    inbox.working_time = get(d, 'compensate_time')
    inbox.days = get(d, 'days')
    const approver = find(users, { _id: get(d, 'approver_id') })
    inbox.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
    inbox.attachment_url = get(d, 'attachment_url')
    inbox.remark_approver = get(d, 'remark_approver')
    inbox.remark_cancel = get(d, 'remark_cancel')
    inbox.remark_hr = get(d, 'remark_hr')
    inbox.created = moment(get(d, 'created')).format('DD/MM/YYYY')
    inbox.remark_request_user = get(d, 'remark_request_user')
    inbox._id = get(d, '_id')
    inbox.canApprove = get(d, 'canApprove')
    inbox.canCancel = get(d, 'canCancel')
    temp.push(inbox)
    return d
  })
  return temp
}

export function createArrayOfProjectSubmitRequest(
  data, users, companys, lobs, positions, clients, departments) {
  const temp = []
  data.map(d => {
    const inbox = {}
    const user = _.find(users, {
      _id: d.user_id,
    })
    inbox.emp_code = get(user, 'emp_code', '')
    inbox.name = `${get(user, 'first_name', '')} ${get(user, 'last_name', '')}`
    inbox.nick_name = get(user, 'nick_name')
    inbox.type = 'Project Information'
    inbox._id = get(d, '_id')
    inbox.project_id = get(d, 'project_id')
    const managers = []
    get(d, 'project_snapshot.project_manager_ids', []).map(id => {
      const manager = find(users, {
        _id: id,
      })
      if (manager) managers.push({ name: `${get(manager, 'first_name', '')} ${get(manager, 'last_name', '')}` })
      return id
    })
    inbox.project_managers = managers
    const approvers = []
    get(d, 'project_snapshot.project_approver_ids', []).map(id => {
      const approver = find(users, {
        _id: id,
      })
      if (approver) approvers.push({ name: `${get(approver, 'first_name', '')} ${get(approver, 'last_name', '')}` })
      return id
    })
    inbox.project_approvers = approvers
    inbox.project_type = get(d, 'project_snapshot.project_type')
    inbox.project_status = get(d, 'project_snapshot.project_status')
    const newClient = find(clients, {
      _id: get(d, 'client_id'),
    })
    inbox.client = newClient ? newClient.name : '-'
    inbox.project_code = get(d, 'project_snapshot.project_number')
    inbox.project_name = get(d, 'project_snapshot.name')
    const pm_supervisor = find(users, {
      _id: get(d, 'project_supervisor_id'),
    })
    inbox.pm_supervisor = pm_supervisor ? `${get(pm_supervisor, 'first_name', '')} ${get(pm_supervisor, 'last_name', '')}` : '-'
    const company = find(companys, {
      _id: get(d, 'project_snapshot.company_id'),
    })
    inbox.company = company ? company.name : '-'
    const lob = find(lobs, {
      _id: get(d, 'project_snapshot.lob_id'),
    })
    inbox.lob = lob ? lob.name : '-'
    const department = find(departments, {
      _id: get(d, 'project_snapshot.department_id'),
    })
    inbox.department = department ? department.name : '-'
    const position = find(positions, {
      _id: get(user, 'position_id'),
    })
    inbox.position = position ? position.name : '-'
    inbox.created = moment(get(d, 'created')).format('YYYYMMDD')
    inbox.default_start_date = moment(get(d, 'project_snapshot.start_date')).format('YYYYMMDD')
    inbox.start_date = moment(get(d, 'project_snapshot.start_date')).format('DD/MM/YYYY')
    inbox.default_end_date = moment(get(d, 'project_snapshot.end_date')).format('YYYYMMDD')
    inbox.end_date = moment(get(d, 'project_snapshot.end_date')).format('DD/MM/YYYY')
    inbox.description = get(d, 'project_snapshot.description')
    const newUser = find(users, {
      _id: get(d, 'updated_by'),
    })
    inbox.modified_by = newUser ? `${get(newUser, 'first_name', '')} ${get(newUser, 'last_name', '')}` : '-'
    inbox.modified = moment(get(d, 'updated')).format('DD/MM/YYYY')
    inbox.remark_request_user = get(d, 'remark_request_user') ? get(d, 'remark_request_user') : '-'
    inbox.remark_approver = get(d, 'remark_approver') ? get(d, 'remark_approver') : '-'
    inbox.canApprove = get(d, 'canApprove')
    inbox.status = get(d, 'status')
    temp.push(inbox)
    return d
  })
  return temp
}

export function createArrayOfTimesheetRequest(timesheetRequests, users, lobs, positions) {
  const temp = []
  timesheetRequests.map(request => {
    const inbox = {}
    const user = _.find(users, {
      _id: request.user_id,
    })
    const approver = find(request.approve_status, { approver_id: localStorage.getItem('_id') })
    inbox.emp_code = get(user, 'emp_code', '')
    inbox.name = `${get(user, 'first_name', '')} ${get(user, 'last_name', '')}`
    inbox.nick_name = get(user, 'nick_name')
    inbox.lob = get(user, 'lob_id') ? findLOBName(user.lob_id, lobs) : '-'
    inbox.position = get(user, 'position_id') ? findPositionName(user.position_id, positions) : '-'
    inbox.default_start_date = moment(request.timesheet_snapshot.month).startOf('month').format('YYYYMMDD')
    inbox.start_date = moment(request.timesheet_snapshot.month).startOf('month').format('DD/MM/YYYY')
    inbox.default_end_date = moment(request.timesheet_snapshot.month).endOf('month').format('YYYYMMDD')
    inbox.end_date = moment(request.timesheet_snapshot.month).endOf('month').format('DD/MM/YYYY')
    inbox.approve_status = request.approve_status
    inbox.status = request.status === 'CANCEL' ? 'REJECTED BY HR' : request.status
    inbox.type = 'Timesheet Request'
    inbox.approver_status = approver.status
    inbox.updated = request.updated
    inbox.created = moment(get(request, 'created')).format('YYYYMMDD')
    inbox.can_approve = request.can_approve
    inbox.remark_request_user = request.remark_request_user ? request.remark_request_user : '-'
    inbox._id = request._id
    inbox.timesheet_snapshot = request.timesheet_snapshot
    temp.push(inbox)
    return inbox
  })
  return temp
}

export function selectColor(status) {
  if (status === 'PENDING' || status === 'PENDING_HR') return '#F0AD4E'
  else if (status === 'APPROVED') return '#5CB85C'
  else if (status === 'REJECTED') return '#D9534F'
  return '#7B7B7B'
}



// WEBPACK FOOTER //
// ./src/function/index.js